import { FC, useEffect, useState } from 'react';
import { Box } from '@mui/material';

type AnimatedDotsProps = {
    interval?: number;   // ms between steps (default 450)
    maxDots?: number;    // number of dots before cycling (default 3)
};

export const AnimatedDots: FC<AnimatedDotsProps> = ({ interval = 300, maxDots = 3 }) => {
  const [dots, setDots] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setDots((d) => (d + 1) % (maxDots + 1));
    }, interval);
    return () => clearInterval(id);
  }, [interval, maxDots]);

  const content = '.'.repeat(dots).padEnd(maxDots, ' ');

  return (
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        display: 'inline-block',
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
        whiteSpace: 'pre',
        width: `${maxDots}ch`,
      }}
    >
      {content}
    </Box>
  );
};
